// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a10a60e4","455":"1a04bae3","645":"30af6e33","766":"62ad13c3","977":"a8041681"}[chunkId] + ".chunk.js";
};